import { useState, useCallback } from 'react';
import { d205Api } from '../../../services/d205Api';

export function useD205Navigation(onLoad: (id: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  const loadList = useCallback(async () => {
    try {
      const res = await d205Api.list(1, 200);
      const ids = (res.data ?? []).map((m) => m.fd150_01);
      setAllIds(ids);
      return ids;
    } catch {
      return [];
    }
  }, []);

  const navTo = useCallback(
    async (idx: number) => {
      if (idx < 0 || idx >= allIds.length) return;
      setCurrentIdx(idx);
      await onLoad(allIds[idx]);
    },
    [allIds, onLoad]
  );

  const navFirst = useCallback(() => navTo(0), [navTo]);
  const navPrev = useCallback(() => navTo(Math.max(0, currentIdx - 1)), [navTo, currentIdx]);
  const navNext = useCallback(
    () => navTo(Math.min(allIds.length - 1, currentIdx + 1)),
    [navTo, currentIdx, allIds.length]
  );
  const navLast = useCallback(() => navTo(allIds.length - 1), [navTo, allIds.length]);

  return {
    allIds,
    currentIdx,
    setCurrentIdx,
    loadList,
    navTo,
    navFirst,
    navPrev,
    navNext,
    navLast,
  };
}
